
import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse } from '../../interfaces/auth/AuthInterface';

import { AcuerdoCitacionSentenciaProps, AgregarCitacionSentenciaParams, AgregarCitacionSentenciaResponse, AudienciaCitacionSentenciaProps, BuscarCitacionSentenciaProps, CambiarEstatusCitacionSentenciaParams, CitacionSentenciaProps, defaultAgregarCitacionSentenciaResponse } from '../../interfaces/sentencia/CitacionSentenciaInterface';

export const ObtenerCitacionSentenciaExpediente = ( id: number ) => {

    return new Promise<CitacionSentenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/CitacionSentencia/ObtenerCitacionSentenciaExpediente/${ id }`, token)
            .then( ({ data } : { data : CitacionSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarCitacionSentencia = ( params: BuscarCitacionSentenciaProps ) => {

    return new Promise<CitacionSentenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/CitacionSentencia/BuscarCitacionSentencia', params, token)
            .then( ({ data } : { data : CitacionSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAcuerdosCitacionSentencia = ( idExpediente: number ) => {

    return new Promise<AcuerdoCitacionSentenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post(`/Api/CitacionSentencia/AcuerdosCitacionSentencia/${ idExpediente }`, {}, token)
            .then( ({ data } : { data : AcuerdoCitacionSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAudienciasCitacionSentencia = ( idExpediente: number ) => {

    return new Promise<AudienciaCitacionSentenciaProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/CitacionSentencia/AudienciasCitacionSentencia/${ idExpediente }`, token)
            .then( ({ data } : { data : AudienciaCitacionSentenciaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const AgregarCitacionSentencia = ( params: AgregarCitacionSentenciaParams ) => {

    return new Promise<AgregarCitacionSentenciaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/CitacionSentencia/AgregarCitacionSentencia', params, token)
            .then( ({ data } : { data : AgregarCitacionSentenciaResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve({ ...defaultAgregarCitacionSentenciaResponse, message: error.message });
            });

        }

    });

}

export const CambiarEstatusCitacionSentencia = ( params: CambiarEstatusCitacionSentenciaParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/CitacionSentencia/CambiarEstatusCitacionSentencia', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}
